// LOCATIONS
export const getLocationsQuery = `
  {
    locations(first: 250, includeLegacy: true, includeInactive: true) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;
